(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dayly-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-scroller')) {
    customElements.define(
      'dl-scroller',
      class DlScroller extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('[data-scroller]');
          this.next = this.querySelector('[data-next]');
          this.prev = this.querySelector('[data-prev]');
          if (!this.scroller) return;
          const step = () => Math.max(160, this.scroller.clientWidth * 0.6);
          this.next?.addEventListener('click', () => {
            const atEnd = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 4;
            this.scroller.scrollBy({ left: atEnd ? -this.scroller.scrollWidth : step(), behavior: 'smooth' });
          });
          this.prev?.addEventListener('click', () => this.scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
          const update = () => {
            const overflow = this.scroller.scrollWidth > this.scroller.clientWidth + 4;
            if (this.next) this.next.hidden = !overflow;
            if (this.prev) this.prev.hidden = !overflow;
          };
          update();
          new ResizeObserver(update).observe(this.scroller);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-fam-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-scroller')) {
    customElements.define(
      'dl-scroller',
      class DlScroller extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('[data-scroller]');
          this.next = this.querySelector('[data-next]');
          this.prev = this.querySelector('[data-prev]');
          if (!this.scroller) return;
          const step = () => Math.max(160, this.scroller.clientWidth * 0.6);
          this.next?.addEventListener('click', () => {
            const atEnd = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 4;
            this.scroller.scrollBy({ left: atEnd ? -this.scroller.scrollWidth : step(), behavior: 'smooth' });
          });
          this.prev?.addEventListener('click', () => this.scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
          const update = () => {
            const overflow = this.scroller.scrollWidth > this.scroller.clientWidth + 4;
            if (this.next) this.next.hidden = !overflow;
            if (this.prev) this.prev.hidden = !overflow;
          };
          update();
          new ResizeObserver(update).observe(this.scroller);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-slider-dots')) {
    customElements.define(
      'dl-slider-dots',
      class DlSliderDots extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dots = [...this.querySelectorAll('[data-dots] button')];
          if (!this.track || !this.dots.length) return;
          this.dots.forEach((d, i) =>
            d.addEventListener('click', () => {
              const s = this.slides[i];
              this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
            })
          );
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) =>
                entries.forEach((en) => {
                  if (!en.isIntersecting) return;
                  const i = this.slides.indexOf(en.target);
                  this.dots.forEach((d, k) => (k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
                }),
              { root: this.track, threshold: 0.6 }
            );
            this.slides.forEach((s) => io.observe(s));
          }
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.indexOf(e.target);
            if (i > -1 && this.dots[i]) this.dots[i].click();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-formula-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-carousel')) {
    customElements.define(
      'dl-carousel',
      class DlCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          const step = (dir) => {
            const card = this.track.firstElementChild;
            const w = card ? card.getBoundingClientRect().width + 14 : this.track.clientWidth;
            const max = this.track.scrollWidth - this.track.clientWidth;
            let next = this.track.scrollLeft + dir * w;
            if (next > max + 2) next = 0;
            if (next < -2) next = max;
            this.track.scrollTo({ left: next, behavior: 'smooth' });
          };
          const prev = this.querySelector('[data-prev]');
          const nextBtn = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', () => step(-1));
          if (nextBtn) nextBtn.addEventListener('click', () => step(1));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-slider')) {
    customElements.define(
      'dl-slider',
      class DlSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.track.children);
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.index = 0;
          if (this.slides.length < 2) return;

          this.dots.forEach((dot) =>
            dot.addEventListener('click', () => {
              this.go(Number(dot.dataset.dot));
              this.stop();
            })
          );

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                  this.setActive(this.slides.indexOf(entry.target));
                }
              });
            },
            { root: this.track, threshold: [0.6] }
          );
          this.slides.forEach((slide) => this.observer.observe(slide));

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.autoplay === 'true' && !reduce && !window.Shopify?.designMode) {
            this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), Number(this.dataset.speed) || 6000);
            ['pointerdown', 'focusin', 'touchstart'].forEach((evt) => this.addEventListener(evt, () => this.stop(), { once: true, passive: true }));
          }

          document.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i > -1) { this.stop(); this.go(i); }
          });
        }
        disconnectedCallback() { this.stop(); this.observer?.disconnect(); }
        stop() { clearInterval(this.timer); }
        go(i) { this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: 'smooth' }); this.setActive(i); }
        setActive(i) {
          this.index = i;
          this.dots.forEach((dot, n) => dot.setAttribute('aria-selected', n === i ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-ingredients')) {
    customElements.define(
      'dl-ingredients',
      class DlIngredients extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('.dl-ing__toggle').forEach((btn) =>
            btn.addEventListener('click', () => {
              const item = btn.closest('.dl-ing__item');
              const open = !item.classList.contains('is-open');
              item.classList.toggle('is-open', open);
              btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            })
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-main-product"]) return;
  try {
    
  if (!customElements.get('dl-buy-box')) {
    customElements.define(
      'dl-buy-box',
      class DlBuyBox extends HTMLElement {
        connectedCallback() {
          try {
            this.offers = JSON.parse(this.querySelector('[data-offers]').textContent) || {};
          } catch (e) {
            this.offers = {};
          }
          this.form = this.querySelector('form[data-product-form]');
          this.variantInput = this.querySelector('[data-variant-input]');
          this.planInput = this.querySelector('[data-plan-input]');
          this.qtyInput = this.querySelector('input[name="quantity"]');
          this.mainId = this.dataset.main;
          const checked = this.querySelector('[data-offer]:checked');
          this.offer = checked ? checked.value : this.mainId;

          this.querySelectorAll('[data-offer]').forEach((r) => r.addEventListener('change', () => this.setOffer(r.value)));
          this.querySelectorAll('[data-plan]').forEach((r) => r.addEventListener('change', () => this.render()));
          this.querySelectorAll('[data-qty]').forEach((b) =>
            b.addEventListener('click', () => {
              const next = Math.min(99, Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
              this.qtyInput.value = next;
            })
          );
          this.form.addEventListener('submit', (e) => this.onSubmit(e));
          if (this.offer && this.offer !== this.mainId) this.setOffer(this.offer);
          else this.render();
        }

        get current() {
          return this.offers[this.offer] || null;
        }

        get isSub() {
          const p = this.querySelector('[data-plan]:checked');
          return !!p && p.value === 'sub';
        }

        setOffer(id) {
          if (!this.offers[id]) return;
          this.offer = id;
          const tpl = this.querySelector(`template[data-head="${id}"]`);
          if (tpl) {
            ['badges', 'title', 'pills'].forEach((part) => {
              const src = tpl.content.querySelector(`[data-part="${part}"]`);
              const slot = this.querySelector(`[data-slot="${part}"]`);
              if (src && slot) slot.innerHTML = src.innerHTML;
            });
          }
          const gal = String(this.offers[id].gallery);
          this.querySelectorAll('[data-gallery]').forEach((el) => { el.hidden = el.dataset.gallery !== gal; });
          this.render();
        }

        render() {
          const o = this.current;
          if (!o) return;
          const set = (sel, val) => this.querySelectorAll(sel).forEach((el) => { el.textContent = val; });
          set('[data-price]', o.price);
          if (o.plan) {
            set('[data-sub-price]', o.subPrice);
            set('[data-per-day]', o.perDay + '/day');
            set('[data-delivery]', o.delivery);
            set('[data-save-text]', '& Save ' + o.save + '%');
          }
          this.variantInput.value = o.variant;
          if (this.planInput) {
            this.planInput.disabled = !(this.isSub && o.plan);
            this.planInput.value = o.plan || '';
          }
          this.querySelector('[data-atc]').disabled = !o.available;
        }

        async onSubmit(e) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (!window.fetch || !cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
          e.preventDefault();
          const o = this.current;
          const btn = this.querySelector('[data-atc]');
          const err = this.querySelector('[data-error]');
          err.hidden = true;
          this.added = false;
          this.fallback = false;
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
          const item = { id: o ? o.variant : parseInt(this.variantInput.value, 10), quantity: Math.max(1, parseInt(this.qtyInput.value, 10) || 1) };
          const plan = o ? o.plan : this.planInput && this.planInput.value;
          if (this.isSub && plan) item.selling_plan = plan;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          try {
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] }),
            });
            let data;
            try {
              data = await res.json();
            } catch (parseErr) {
              // Unexpected response (e.g. a bot check page): fall back to a normal form post.
              this.fallback = true;
              throw parseErr;
            }
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
            this.added = true;
            const upd = await fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'] }),
            });
            const state = await upd.json();
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(state);
            document.dispatchEvent(new CustomEvent('dayly:cart:added', { detail: { item } }));
          } catch (ex) {
            if (this.added) {
              // Item is in the cart but the drawer could not refresh: show the cart page instead.
              window.location.href = root + 'cart';
              return;
            }
            if (this.fallback || ex instanceof TypeError) {
              this.fallback = false;
              HTMLFormElement.prototype.submit.call(this.form);
              return;
            }
            err.textContent = ex.message || 'Something went wrong. Please try again.';
            err.hidden = false;
          } finally {
            btn.removeAttribute('aria-busy');
            btn.disabled = o ? !o.available : false;
          }
        }
      }
    );
  }

  if (!customElements.get('dl-gallery')) {
    customElements.define(
      'dl-gallery',
      class DlGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.thumbs = [...this.querySelectorAll('[data-thumb]')];
          this.strip = this.querySelector('[data-thumbs]');
          this.index = 0;
          this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
          const next = this.querySelector('[data-thumbs-next]');
          if (next) next.addEventListener('click', () => this.go((this.index + 1) % this.slides.length));
          if ('IntersectionObserver' in window && this.track) {
            const io = new IntersectionObserver(
              (entries) => entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) this.mark(this.slides.indexOf(en.target)); }),
              { root: this.track, threshold: [0.6] }
            );
            this.slides.forEach((s) => io.observe(s));
          }
        }
        go(i) {
          const s = this.slides[i];
          if (!s) return;
          this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          this.mark(i);
        }
        mark(i) {
          if (i < 0) return;
          this.index = i;
          this.thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
          const t = this.thumbs[i];
          if (t && this.strip) {
            const l = t.offsetLeft - this.strip.offsetLeft;
            if (l < this.strip.scrollLeft || l + t.offsetWidth > this.strip.scrollLeft + this.strip.clientWidth) this.strip.scrollTo({ left: l - 8, behavior: 'smooth' });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dayly-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-video')) {
    customElements.define(
      'dl-video',
      class DlVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('.dl-vid__play');
          if (!this.video || !this.button) return;
          this.button.addEventListener('click', () => this.play());
          this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
          this.video.addEventListener('ended', () => { this.video.hidden = true; });
        }
        play() {
          document.querySelectorAll('dl-video video').forEach((other) => { if (other !== this.video) other.pause(); });
          this.video.hidden = false;
          this.classList.add('is-playing');
          const p = this.video.play();
          if (p && p.catch) p.catch(() => {});
          this.video.focus({ preventScroll: true });
        }
      }
    );
  }
  if (!customElements.get('dl-scroller')) {
    customElements.define(
      'dl-scroller',
      class DlScroller extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('[data-scroller]');
          this.next = this.querySelector('[data-next]');
          this.prev = this.querySelector('[data-prev]');
          if (!this.scroller) return;
          const step = () => Math.max(160, this.scroller.clientWidth * 0.6);
          this.next?.addEventListener('click', () => {
            const atEnd = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 4;
            this.scroller.scrollBy({ left: atEnd ? -this.scroller.scrollWidth : step(), behavior: 'smooth' });
          });
          this.prev?.addEventListener('click', () => this.scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
          const update = () => {
            const overflow = this.scroller.scrollWidth > this.scroller.clientWidth + 4;
            if (this.next) this.next.hidden = !overflow;
            if (this.prev) this.prev.hidden = !overflow;
          };
          update();
          new ResizeObserver(update).observe(this.scroller);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var out = (fmt || ('$' + '{' + '{amount}' + '}'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
    var el = document.createElement('textarea');
    el.innerHTML = out;
    return el.value;
  }
  document.querySelectorAll('[data-kr-bb]').forEach(function (root) {
    var fmt = root.getAttribute('data-money-format');
    var plan = 'sub';
    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return root.querySelectorAll(sel); }
    function activeCard() {
      var group = q('.kr-bb__cards.is-active');
      if (!group) return null;
      var card = group.querySelector('.kr-bb__card.is-active') || group.querySelector('.kr-bb__card');
      if (card) card.classList.add('is-active');
      return card;
    }
    function setImg(img, src, srcset) {
      if (!img) return;
      if (!img.dataset.origSrc) { img.dataset.origSrc = img.getAttribute('src') || ''; img.dataset.origSrcset = img.getAttribute('srcset') || ''; }
      var useSrc = src || img.dataset.origSrc;
      var useSet = src ? '' : img.dataset.origSrcset;
      if (img.getAttribute('src') === useSrc) return;
      if (useSet) img.setAttribute('srcset', useSet); else img.removeAttribute('srcset');
      img.src = useSrc;
    }
    function goTo(gallery, i, smooth) {
      var track = gallery && gallery.querySelector('[data-kr-track]');
      if (!track) return;
      var n = track.children.length;
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      markThumb(gallery, i);
    }
    function markThumb(gallery, i) {
      var thumbs = gallery.querySelectorAll('[data-kr-thumb]');
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) {
          var row = t.parentNode;
          var left = t.offsetLeft - row.offsetLeft;
          if (left < row.scrollLeft || left + t.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollTo({ left: left - 8, behavior: 'smooth' });
        }
      });
      gallery.dataset.index = i;
    }
    function wakeImages(gallery) {
      gallery.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    function swapImage(card) {
      var gallery = q('.kr-bb__set-gallery.is-active');
      if (!gallery) return;
      var firstSlide = gallery.querySelector('[data-kr-slide] img');
      var firstThumb = gallery.querySelector('[data-kr-thumb] img');
      setImg(firstSlide, card.dataset.image, '');
      setImg(firstThumb, card.dataset.thumb || card.dataset.image, '');
      goTo(gallery, 0, false);
    }
    qa('.kr-bb__set-gallery').forEach(function (gallery) {
      var track = gallery.querySelector('[data-kr-track]');
      if (!track) return;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (String(i) !== gallery.dataset.index) markThumb(gallery, i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(gallery, (+gallery.dataset.index || 0) + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      gallery.dataset.index = 0;
    });
    function preloadCards() {
      qa('.kr-bb__card[data-image]').forEach(function (c) {
        if (c.dataset.image) { var i = new Image(); i.src = c.dataset.image; }
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(preloadCards); else setTimeout(preloadCards, 1500);
    function update() {
      var card = activeCard();
      if (!card) return;
      var price = +card.dataset.price;
      var sub = +card.dataset.subPrice;
      var hasPlan = !!card.dataset.planId;
      var subOpt = q('[data-option="sub"]');
      subOpt.hidden = !hasPlan;
      if (!hasPlan) plan = 'once';
      qa('[data-option]').forEach(function (o) {
        var on = o.dataset.option === plan;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      qa('[data-kr-sub-price]').forEach(function (e) { e.textContent = money(sub, fmt); });
      qa('[data-kr-compare]').forEach(function (e) { e.textContent = money(price, fmt); });
      qa('[data-kr-price]').forEach(function (e) { e.textContent = money(price, fmt); });
      qa('[data-kr-discount]').forEach(function (e) { e.textContent = card.dataset.discount; });
      q('[data-kr-variant]').value = card.dataset.variantId;
      var planInput = q('[data-kr-plan]');
      planInput.value = plan === 'sub' ? card.dataset.planId : '';
      planInput.disabled = plan !== 'sub';
      var btn = q('[data-kr-submit]');
      if (!btn.dataset.label) btn.dataset.label = btn.textContent;
      var available = card.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.label : 'Sold out';
    }
    var form = q('[data-kr-bb-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
        e.preventDefault();
        var btn = q('[data-kr-submit]');
        var err = q('[data-kr-error]');
        err.hidden = true;
        btn.disabled = true;
        btn.classList.add('is-loading');
        var data = new FormData(form);
        data.append('sections', 'cart-drawer,cart-icon-bubble');
        data.append('sections_url', window.location.pathname);
        fetch(form.getAttribute('action') + '.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (r) {
            if (!r.ok || r.json.status) {
              err.textContent = r.json.description || r.json.message || 'Sorry, something went wrong. Please try again.';
              err.hidden = false;
              return;
            }
            drawer.classList.remove('is-empty');
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
            drawer.renderContents(r.json);
            if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open(btn);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            btn.classList.remove('is-loading');
            update();
          });
      });
    }
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-set-tab]');
      var card = e.target.closest('.kr-bb__card');
      var opt = e.target.closest('[data-option]');
      var thumb = e.target.closest('[data-kr-thumb]');
      var step = e.target.closest('[data-kr-step]');
      if (tab) {
        var set = tab.dataset.setTab;
        qa('[data-set-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        qa('.kr-bb__cards, .kr-bb__set-gallery, .kr-bb__set-info').forEach(function (g) { g.classList.toggle('is-active', g.dataset.set === set); });
        var shown = q('.kr-bb__set-gallery.is-active');
        if (shown) wakeImages(shown);
        plan = 'sub';
        update();
        var ac = activeCard();
        if (ac) swapImage(ac);
      } else if (card) {
        card.parentNode.querySelectorAll('.kr-bb__card').forEach(function (c) { c.classList.toggle('is-active', c === card); });
        update();
        swapImage(card);
      } else if (opt) {
        plan = opt.dataset.option;
        update();
      } else if (thumb) {
        goTo(thumb.closest('.kr-bb__set-gallery'), +thumb.dataset.krThumb, true);
      } else if (step) {
        var gal = step.closest('.kr-bb__set-gallery');
        goTo(gal, (+gal.dataset.index || 0) + (+step.dataset.krStep), true);
      }
    });
    update();
    var initCard = activeCard();
    if (initCard) swapImage(initCard);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-kr-sticky]').forEach(function (el) {
    var target = document.getElementById(el.dataset.target);
    function update() {
      var show = window.scrollY > 600;
      if (target) {
        var r = target.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) show = false;
      }
      el.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Videos load nothing until a visitor taps play, then play with sound and controls.
  function load(video) {
    if (video.dataset.krLoaded) return;
    video.dataset.krLoaded = '1';
    video.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
    video.load();
  }
  function play(fig) {
    var video = fig.querySelector('video[data-kr-click-video]');
    if (!video) return;
    document.querySelectorAll('video[data-kr-click-video]').forEach(function (v) { if (v !== video) v.pause(); });
    load(video);
    video.controls = true;
    fig.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () { fig.classList.remove('is-playing'); });
    if (!video.dataset.krBound) {
      video.dataset.krBound = '1';
      video.addEventListener('ended', function () { fig.classList.remove('is-playing'); video.controls = false; });
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kr-ugc .kr-video__play');
    if (!btn) return;
    play(btn.closest('[data-kr-ugc]'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
